"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated - will be removed in phase II of MM migration
 */
function restoreRelativeUri(items) {
    return items.map(function (item) {
        if (item.mediaType === 'secure_music') {
            return item;
        }
        else {
            return Object.assign({}, item, { relativeUri: item.uri });
        }
    });
}
exports.restoreRelativeUri = restoreRelativeUri;
/**
 * @deprecated - will be removed in phase II of MM migration
 */
function transformRawData(items) {
    return items.map(function (rawData) {
        var mediaItem = {};
        mediaItem.fileName = rawData.title || '';
        if (rawData.mediaType === 'secure_music') {
            var audioFilesData = rawData.fileOutput && rawData.fileOutput.audio;
            var shortPreviewFileData = audioFilesData && audioFilesData.filter(function (file) { return file.tag === 'preview-short'; })[0];
            mediaItem.shortPreviewFileName = (shortPreviewFileData && shortPreviewFileData.url) || '';
            mediaItem.previewFileName = rawData.previewFileName || '';
            mediaItem.fileUrl = rawData.fileUrl || '';
        }
        else {
            mediaItem.relativeUri = rawData.fileName || '';
            mediaItem.width = Number(rawData.width) || 0;
            mediaItem.height = Number(rawData.height) || 0;
        }
        return mediaItem;
    });
}
exports.transformRawData = transformRawData;
